export const DEMO_ASSETS_ROOT_URL = 'https://raw.githubusercontent.com/polygonjs/polygonjs-assets/master';
